import { useContext, useEffect, useRef, useState } from "react";
import { AiOutlinePlusSquare, AiOutlineShoppingCart } from "react-icons/ai";
import Spinner from "../icons/Spinner";
import { addMultiItemsToCart } from "@/services/cart/cart";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";
import { useCart } from "@/contexts/cart/CartContext";
import { AppContext } from "@/contexts/appContexts";
import CartInfo from "../Modals/CartInfo2";
import { getProductsBySkuV2 } from "@/services/elasticsearch/getProducts";
import NextImage from "../NextImage";
import { validateImgSrc } from "@/utils/global";

function ProductsBundle({ product, bundle, relatedProducts, t }) {
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [totalDiscount, settotalDiscount] = useState();
  const [totalPay, settotalPay] = useState();
  const [totalItems, settotalItems] = useState();
  const { dispatch } = useCart();
  const { setOpenSelectCityPopUp, setProductInfo } = useContext(AppContext);
  const selectedCity = Cookies.get("region_id");
  const handshake = Cookies.get("handshake");
  const mage = Cookies.get("mage");
  const quote = Cookies.get("quote");
  const addToCartRef = useRef();

  const handleAddProductsBundle = () => {
    const parentSKU = product?.sku;
    const childrenSKUS = bundle?.child_details?.map((item) => item?.sku) || [];

    setIsLoading(true);
    if (
      selectedCity &&
      selectedCity !== "NaN" &&
      !isNaN(parseInt(selectedCity))
    ) {
      addMultiItemsToCart(
        handshake,
        mage,
        quote,
        [parentSKU, ...childrenSKUS],
        selectedCity,
        [product, ...bundle?.child_details]
      )
        .then(({ data, error, err }) => {
          if (error)
            return toast.error(
              err?.response?.data?.error?.message ||
                "Faild to add products to cart, try again later."
            );
          toast.success(data?.msg);
          Cookies.set("quote", data?.quoteId);

          const childrenData = bundle?.child_details?.map((item, idx) => ({
            ...item,
            ...data?.cart[idx + 1],
            prices_with_tax: { price: data?.cart[idx + 1].price },
            image: `${
              process.env.NEXT_PUBLIC_IMAGE_BASEURL
            }/media/catalog/product${
              bundle?.child_details[idx + 1]?.product_image
            }`,
          }));
          const productsData = [
            {
              image: `${
                process.env.NEXT_PUBLIC_IMAGE_BASEURL
              }/media/catalog/product${
                product?.image ? product?.image[0] : ""
              }`,
              back_orders: product?.back_orders,
              prices_with_tax: product?.prices_with_tax,
              ...data?.cart[0],
            },
            ...childrenData,
          ];

          // get products data
          getProductsBySkuV2([parentSKU, ...childrenSKUS], handshake).then(
            ({ data }) => {
              if (data?.length) {
                const products = data.map((item) => item?._source);
                setProductsData(products);
              }
            }
          );
          setTimeout(() => {
            dispatch({ type: "ADD_ITEMS", payload: productsData });
            setShowPopup(true);
          }, 500);
        })
        .finally(() => setIsLoading(false));
    } else {
      product?.sku && setProductInfo({ product, addToCartRef });
      setOpenSelectCityPopUp(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (product && product?.bundle_discount_products?.length) {
      let discountOfChildren = 0;
      let priceOfChildren = 0;
      for (let i = 0; i < bundle?.child_details?.length; i++) {
        discountOfChildren += +bundle?.child_details[i].discount_amount;
        bundle?.child_details[i]?.product_special_price
          ? (priceOfChildren +=
              +bundle?.child_details[i]?.product_special_price)
          : (priceOfChildren += +bundle?.child_details[i]?.product_price);
      }
      let totalDiscount = +bundle?.discount_amount + discountOfChildren;
      let totalPrice =
        +product?.prices_with_tax?.price + priceOfChildren - totalDiscount;
      settotalDiscount(totalDiscount);
      settotalPay(totalPrice);
      // Total Items

      settotalItems(1 + bundle?.child_details?.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Two digits number

  function truncate(number, decimel = 2) {
    const formattedNumber = Number(number?.toFixed(decimel));
    return formattedNumber.toFixed(decimel);
  }

  return (
    <div className="p-2 my-10 border rounded-md two-products-bundle">
      <h3 className="mb-1 text-xl font-bold">{bundle?.block_title}</h3>

      <h5 className="font-[500] text-[18px] mb-3">{bundle?.cart_message}</h5>

      <div className="grid grid-cols-6 gap-2">
        <div className="flex items-center max-[768px]:col-span-6 max-[1200px]:col-span-4 col-span-4 overflow-x-auto red-scrollbar">
          <>
            <div className="bg-gray-100 p-3 rounded-md min-w-[180px] max-w-[180px] flex flex-col items-center">
              <div className="relative">
                <NextImage
                  src={validateImgSrc(
                    `${
                      process.env.NEXT_PUBLIC_IMAGE_BASEURL
                    }/media/catalog/product/${
                      product?.image ? product?.image[0] : ""
                    }`
                  )}
                  width={130}
                  height={130}
                  className="object-contain w-32 h-32"
                  alt="Prod Img!"
                />

                {bundle?.discount_amount ? (
                  <div className="absolute top-0 left-0 p-1 text-xs font-semibold text-white rounded-sm bg-red">
                    -{bundle?.discount_amount}
                    {t("SAR")}
                  </div>
                ) : null}
              </div>
              <h5 className="mt-1 text-lg font-bold text-center">
                {truncate(+product?.prices_with_tax?.price)} {t("SAR")}
              </h5>
              {+product?.prices_with_tax?.original_price &&
              +product?.prices_with_tax?.original_price !=
                +product?.prices_with_tax?.price ? (
                <h5 className="mb-1 font-semibold text-center line-through text-zinc-400">
                  {" "}
                  {truncate(+product?.prices_with_tax?.original_price)}{" "}
                  {t("SAR")}
                </h5>
              ) : null}
              <h4 className="text-center text-[14px]">{product?.name[0]}</h4>
            </div>
            <AiOutlinePlusSquare className="mx-3 text-blue" size="27px" />
          </>
          {bundle?.child_details?.map((item, idx) => (
            <>
              <div
                key={idx}
                className="bg-gray-100 p-3 rounded-md min-w-[180px] max-w-[180px] flex flex-col items-center"
              >
                <div className="relative">
                  <NextImage
                    src={validateImgSrc(
                      `${process.env.NEXT_PUBLIC_IMAGE_BASEURL}/media/catalog/product/${item.product_image}`
                    )}
                    className="object-contain w-32 h-32"
                    width={130}
                    height={130}
                    alt="Prod Img!"
                  />
                  {item.discount_amount != "0" &&
                  item.discount_amount != 0 &&
                  item.discount_amount != "" ? (
                    <div className="absolute top-0 left-0 p-1 text-xs font-semibold text-white rounded-sm bg-red">
                      -{item.discount_amount} {t("SAR")}
                    </div>
                  ) : null}
                </div>
                <h5 className="mt-1 text-lg font-bold text-center">
                  {item?.product_special_price === ""
                    ? truncate(+item?.product_price)
                    : truncate(+item?.product_special_price)}{" "}
                  {t("SAR")}
                </h5>

                {item?.product_special_price ? (
                  item?.product_price == item?.product_special_price ? null : (
                    <h5 className="mb-1 font-semibold text-center line-through text-zinc-400">
                      {truncate(+item?.product_price)} {t("SAR")}
                    </h5>
                  )
                ) : null}

                <h4 className="text-center text-[14px]">
                  {item?.product_name}
                </h4>
              </div>
              {idx !== bundle?.child_details?.length - 1 ? (
                <AiOutlinePlusSquare className="mx-3 text-blue" size="27px" />
              ) : null}
            </>
          ))}
        </div>
        <div className="flex flex-col items-center justify-center col-span-2 p-2 rounded-md max-[768px]:col-span-6 max-[1200px]:col-span-2">
          <div className="flex flex-col items-center justify-center w-24 h-24 border-2 rounded-full border-red text-red">
            <span className="font-semibold">{t("save")}</span>
            <span className="text-xl font-bold leading-none">
              {totalDiscount}
            </span>
            <span className="font-semibold">{t("SAR")}</span>
          </div>
          <button
            ref={addToCartRef}
            onClick={handleAddProductsBundle}
            disabled={isLoading}
            className="mx-auto w-fit text-lg bg-red disabled:bg-lightred hover:bg-lightred text-white font-semibold p-1.5 px-4 rounded-full flex items-center justify-center my-4"
          >
            {isLoading ? (
              <span className="flex items-center w-full gap-4 flex-nowrap">
                <span>{t("adding")}...</span>
                <Spinner width={20} />
              </span>
            ) : (
              <span className="flex items-center gap-4 ">
                <span>
                  {t("buy")} {totalItems} {t("together")} {t("for")}{" "}
                  {truncate(totalPay, 0)} {t("SAR")}
                </span>
                <AiOutlineShoppingCart size="19px" className="mx-1" />
              </span>
            )}
          </button>
        </div>
      </div>
      <CartInfo
        active={showPopup}
        setActive={setShowPopup}
        products={productsData}
        relatedProducts={relatedProducts}
        totals={truncate(totalPay)}
      />
    </div>
  );
}

export default ProductsBundle;
